import { Navigate } from 'react-router-dom'
import { useProductMode } from '../contexts/ProductModeContext'
import LoadingSpinner from './LoadingSpinner'

interface HumanLayerPortalRouteProps {
  children: React.ReactNode
}

/** Blocks tutor/school portal routes when platform is in AI-only mode. */
const HumanLayerPortalRoute = ({ children }: HumanLayerPortalRouteProps) => {
  const { humanTutorLayerEnabled, loading } = useProductMode()

  if (loading) {
    return <LoadingSpinner />
  }

  if (!humanTutorLayerEnabled) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default HumanLayerPortalRoute
